export const LOADING = 'loading'